<div class="test-server-banner"
  *ngIf="isTestServer">
  테스트 서버
</div>
